import React from "react";
import Header from "../../components/Header";

import NKAvatar from "../../assets/media/mocks/nk.png";
import CMAvatar from "../../assets/media/mocks/cm.png";
import AnthonyAvatar from "../../assets/media/mocks/Anthony.png";
import MarkAvatar from "../../assets/media/mocks/Mark.png";
import "./index.css";
import { CommaSeparateValue } from "../../Utils/utils";

// NOTE: use mock data
const TEAM = [
  {
    avatar: AnthonyAvatar,
    name: "Anthony",
    prospects: 24,
    deals: 6,
    dealValue: 4252000,
    totalRevenue: 105342,
    globalRanking: 1,
  },
  {
    avatar: CMAvatar,
    name: "Christopher",
    prospects: 24,
    deals: 6,
    dealValue: 4252000,
    totalRevenue: 105342,
    globalRanking: 2,
  },
  {
    avatar: MarkAvatar,
    name: "Mark",
    prospects: 24,
    deals: 6,
    dealValue: 4252000,
    totalRevenue: 105342,
    globalRanking: 3,
  },
  {
    avatar: NKAvatar,
    name: "Nidhi",
    prospects: 24,
    deals: 6,
    dealValue: 4252000,
    totalRevenue: 105342,
    globalRanking: 4,
  },
];

class Team extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      team: TEAM,
    };
  }

  componentDidMount() {
    if (!this.props.location.state && this.props.location.state.role !== 0) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
    }
  }

  render() {
    const { brand, team } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    return (
      <div id="page-container">
        <Header username={username} role={role} brand={brand} />
        <main id="main-container" className="team-page-container">
          <div className="team-row">
            <div className="team-row-item">Team Member</div>
            <div className="team-row-item">Prospects</div>
            <div className="team-row-item">Deals</div>
            <div className="team-row-item">Deal Value</div>
            <div className="team-row-item">Total Revenue</div>
            <div className="team-row-item">Global Ranking</div>
          </div>
          {team.map((item, index) => (
            <div className="team-row" key={index}>
              <div className="team-row-item">
                <img src={item.avatar} alt="avatar" className="avatar" />
                <span className="name">{item.name}</span>
              </div>
              <div className="team-row-item">{item.prospects}</div>
              <div className="team-row-item">{item.deals}</div>
              <div className="team-row-item">
                £{CommaSeparateValue(item.dealValue)}
              </div>
              <div className="team-row-item">
                £{CommaSeparateValue(item.totalRevenue)}
              </div>
              <div className="team-row-item">{item.globalRanking}</div>
            </div>
          ))}
        </main>
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/screens/Team/index.js